import { Link } from "react-router-dom";
import { EnvelopeIcon } from "@heroicons/react/24/solid";
import { OFFICIAL_LINE } from "@/constants/common";

const Footer = () => {
  return (
    <footer className="bg-[#333333] py-8 text-white">
      <div className="brand-container grid grid-cols-1 gap-4 p-4 lg:grid-cols-4">
        <div className="flex h-full flex-col lg:col-span-2">
          <h4 className="text-lg tracking-widest">YUAN COFFEE 小院咖啡</h4>
          <div className="text-md mb-8 mt-8 flex flex-col gap-4 lg:mb-0 lg:mt-auto lg:gap-2 lg:text-sm">
            <div>
              <Link
                to={OFFICIAL_LINE.LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2"
              >
                <img src="/images/icon-line.svg" className="size-6" alt="小院店家LINE" />
                <p>@fkb4472p</p>
              </Link>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex size-6 items-center justify-center rounded-md bg-white">
                <EnvelopeIcon className="size-4 text-secondary" />
              </div>
              <p>yuancoffee.tw@gmail.com</p>
            </div>
          </div>
        </div>
        <div className="col-span-1">
          <h5 className="text-md flex h-7 items-end !leading-none lg:text-sm">顧客服務</h5>
          <ul className="*:text-md mt-8 flex flex-col gap-4 *:lg:text-sm">
            <li>
              <Link to="/return-policy">退換貨政策</Link>
            </li>
            <li>
              <Link to="/terms-of-service">服務條款</Link>
            </li>
            <li>
              <Link to="/privacy-policy">隱私權政策</Link>
            </li>
          </ul>
        </div>
        <div className="col-span-1 mt-8 lg:mt-0">
          <h5 className="text-md flex h-7 items-end !leading-none lg:text-sm">付款方式</h5>
          <ul className="*:text-md mt-8 flex flex-col gap-4 *:lg:text-sm">
            <li>銀行轉帳</li>
            <li>超商貨到付款</li>
            <li>信用卡 (綠界金流)</li>
          </ul>
        </div>
      </div>
      <div className="mt-8 border-t border-neutral/50">
        <div className="brand-container flex flex-col items-center justify-between gap-2 pt-4 lg:flex-row">
          <p className="order-2 text-xs text-neutral lg:order-1">
            @{new Date().getFullYear()} 小院咖啡. All rights reserved.
          </p>
          <div className="order-1 lg:order-2">
            <ul className="flex items-center gap-1">
              <li>
                <img
                  src="/images/icon-payment-visa.svg"
                  loading="lazy"
                  className="w-atuo h-6"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="/images/icon-payment-master.svg"
                  loading="lazy"
                  className="w-atuo h-6"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="/images/icon-payment-jcb.png"
                  loading="lazy"
                  className="w-atuo h-6"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="/images/icon-cvs-7-eleven.svg"
                  loading="lazy"
                  className="w-atuo h-6"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="/images/icon-cvs-family-mart.svg"
                  loading="lazy"
                  className="w-atuo h-6"
                  alt=""
                />
              </li>
              <li>
                <img
                  src="/images/icon-cvs-hi-life.svg"
                  loading="lazy"
                  className="w-atuo h-6"
                  alt=""
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
